/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'materials': {
    width: 20,
    height: 22,
    viewBox: '0 0 20 22',
    data: '<path pid="0" d="M17.8 0l-.001 2.8H19.2V22H2.119a2.117 2.117 0 0 1-2.114-1.962L0 19.888V1.9C0 .858.8 0 1.806 0H17.8zM7.25 10.762l-2.215-2.29-2.285 2.364V3.8h-.944c-.29 0-.564-.072-.806-.199v16.286c0 .573.436 1.046.997 1.106l.122.007H18.2V3.8H7.25v6.962zm-3.5-2.399l1.286-1.329L6.25 8.29V3.8h-2.5v4.563zM16.8 1H1.806c-.403 0-.749.337-.8.786L1 1.9v.016c.008.497.374.884.806.884H16.8V1z" _fill="#969696" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/materials.js